/* eslint-disable array-bracket-newline */
export default {
    filterOption: {
        pageNumber: 1,
        pageSize: 1000,
        searchWord: {
            // 검색유형
            field: '',
            // 검색어
            value: '',
            // 검색조건
            condition: 'like',
        },
    },
    isWorkerSettingDialogOpen: false,
    selectedSettingGroup: {
        name: '',
        id: 0,
    },
    penaltyGroupWorkerList: [],
    penaltyGroupAvailableWorkerList: [],
    registerList: [
    // {
    //   name: '',
    //   code: '',
    //   hubEmployeeNumber: '',
    //   groupName: '',
    // },
    ],
    unregisterList: [
    // {
    //   name: '',
    //   code: '',
    //   hubEmployeeNumber: '',
    //   groupName: '',
    // },
    ],
};
